module.exports = __webpack_public_path__ + "static/img/格物智安工地安全管理平台操作说明-6.df27ee2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentation/格物智安工地安全管理平台操作说明-6.jpg
// module id = dsUv
// module chunks = 0